import script from "./DisclaimerSiteInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./DisclaimerSiteInfo.vue?vue&type=script&setup=true&lang=js"

import "./DisclaimerSiteInfo.vue?vue&type=style&index=0&id=7c3250d2&lang=css"

const __exports__ = script;

export default __exports__